module.exports = __webpack_public_path__ + "img/physical_combo.4a338dd6.png";